// import components
import { styled, InputAdornment, InputAdornmentProps } from '@mui/material';

export const StyledInputAdornment = styled(InputAdornment)<InputAdornmentProps>(
  () => ({
    fontSize: '16px'
  })
);
